/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';

// using CompatRouter for React Router v5 to v6 migration( https://github.com/remix-run/react-router/discussions/8753 )

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <CompatRouter>
        <Provider store={store()}>
          <App />
        </Provider>
      </CompatRouter>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
